var _g, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.715,
    height: 143,
    viewBox: "0 0 150.715 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1251"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1959",
    d: "M150.716 135.929h-8.827V64.701h-26.776v71.228h-8.827V93.016H79.8v42.914h-8.823V78.842H44.5v57.087h-8.832v-35.843H8.827v35.843H0v7.07h150.716Z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 142",
    cx: 36.629,
    cy: 36.629,
    r: 36.629,
    fill: "#39beec"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 143",
    cx: 36.629,
    cy: 36.629,
    r: 36.629,
    transform: "translate(47.529)",
    fill: "#1b60a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.e32610aff6e8a1426c0970df13c455d3.svg";
export { ForwardRef as ReactComponent };